import { render, staticRenderFns } from "./homeGovernment.vue?vue&type=template&id=42d96d74&scoped=true&"
import script from "./homeGovernment.vue?vue&type=script&lang=js&"
export * from "./homeGovernment.vue?vue&type=script&lang=js&"
import style0 from "./homeGovernment.vue?vue&type=style&index=0&id=42d96d74&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42d96d74",
  null
  
)

export default component.exports